import woodtypes from "@/common/woodtypes";
import {logSearchPageSize, watchlistSearchPageSize} from "@/common/config";

export const GALLERY_VIEW = {
	TEASER: 'teaser',
	LIST: 'list'
};
export const SEARCH_TYPE = {
	BLOCK: 1,
	PALLET: 2
};
export const SEARCH_DISPLAY_TYPE = {
	TEASER: 'teaser',
	TABLE: 'table'
};
export const GALLERY_SORTING = {
	NAME: 1,
	TRADENAME: 2,
	BOTANICALNAME: 3
};
export const GALLERY_SORTING_DIRECTION = {
	ASCENDING: false,
	DESCENDING: true
};
export const INITIAL_SPECIES_SEARCH_PARAMS = {
	color: 0,
	application: 0,
	availability: [1, 2, 3, 4],
	pricegroup: [1, 2, 3, 4],
	fsc: false,
	pefc: false,
	occurrence: 0
};
export const INITIAL_LOG_SEARCH_PARAMS = {
	woodtype: woodtypes.VENEER,
	searchType: SEARCH_TYPE.BLOCK,
	species: null,
	logNo: null,
	palletNo: null,
	thickness: null,
	characteristic: null,
	qualities: [],
	structure: null,
	lengthFrom: null,
	lengthMax: null,
	widthFrom: null,
	widthTo: null,
	/*
	areaFrom: null,
	areaTo: null,
	*/
	gradeFrom: null,
	gradeTo: null,
	internalQuality: null,
	info: null,
	limit: logSearchPageSize,
	offset: 1,
	orderBy: [0],
	orderDirection: [false]
};
export const INITIAL_VIRTUAL_LOG = {
	name: '',
	species: null,
	bundles: [],
	owner: 0,
	createdBy: 0,
	logNo: '',
	logArea: 0.0,
	thicknessMm: 0.0,
	maxLength: 0,
	customerQualityName: '',
	internalQualityName: '',
	structure: '',
	characteristic: '',
	bundleCount: 0,
	teaser: '',
	backColor: '',
	grade: 0.0,
	description: '',
	imageUrls: [],
	logsMeta: []
};
export const INITIAL_LOG_FILTER_DATA = {
	thicknesses: [],
	characteristics: [],
	qualities: [],
	structures: []
};
export const LANGUAGES = {
	0: 'German',
	1: 'English'
};
export const DOMAINS = {
	// sg domains
	0: {
		de: "https://sg-warehouse.com/",
		en: "https://en.sg-warehouse.com/"
	},
	// neutral domains
	1: {
		de: "https://veneer.store/",
		en: "https://en.veneer.store/"
	}
};
export const ZOHO_LANGUAGE_ISO = {
	"German": "de",
	"Deutsch": "de",
	"English": "en",
	"Englisch": "en"
};
// map currency iso codes to symbol
export const CURRENCIES = {
	'EUR': '€',
	'USD': '$'
};
export const PRODUCT_TYPES = {
	'Veneer': 0
};
export const SNACK_LEVEL = {
	INFO: 0,
	SUCCESS: 1,
	ERROR: 2
};
export const INITIAL_WATCHLISTS_PAGINATION = {
	sortBy: 'crdate',
	descending: true,
	page: 1,
	rowsPerPage: watchlistSearchPageSize,
	rowsNumber: 0
};